import {
  useGravityFormsContext,
  GravityFormsContext,
} from "../../hooks/use-gravity-forms";
import GravityFormsForm from "./GravityFormsForm";

const GravityForms = ({ form }) => {
  const gfData = useGravityFormsContext(form);
  // console.log("GF Data", gfData);
  return (
    <GravityFormsContext.Provider value={gfData}>
      <GravityFormsForm />
    </GravityFormsContext.Provider>
  );
};

export default GravityForms;
